import React, { useState } from 'react'

// Material UI
import AppBar from '@material-ui/core/AppBar'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import CardHeader from '@material-ui/core/CardHeader'
import Checkbox from '@material-ui/core/Checkbox'
import Divider from '@material-ui/core/Divider'
import Grid from '@material-ui/core/Grid'
import FormControl from '@material-ui/core/FormControl'
import Input from '@material-ui/core/Input'
import InputAdornment from '@material-ui/core/InputAdornment'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'

// Icons
import IconButton from '@material-ui/core/IconButton'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import AttachMoneyIcon from '@material-ui/icons/AttachMoney'
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked'
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked'

// Components
import SquarePayment from '../SquarePayment/SquarePayment'

// Style
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
    card: {
        background: "white",
        cursor: "pointer",
        marginTop: 15,
        marginBottom: 15,
        marginLeft: 15,
        marginRight: 15,
    },
    name: {
        marginBottom: 15,
    },
    pickup: {
        top: 15,
        marginBottom: 15,
    },
    footer: {
        backgroundColor: "#f5f5f5",
        position: "fixed",
        width: "100%",
        bottom: 0,
    },
    continueButton: {
        width: "100%",
        backgroundColor: "#003366",
    },
    loading: {
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
    },
}));

export default function PaymentPage({ toggleDrawer, subTotal, taxes }) {

    let total = 28.75

    const [tipsAmountChoice, setTipsAmountChoice] = useState('')
    const [tipsAmount, setTipsAmount] = useState(0)
    const [totalAmount, setTotalAmount] = useState(total)

    const classes = useStyles()
    const styles = { alignItems: "baseline" }

    const handleTipsChoice = (choice) => {

        setTipsAmountChoice(choice)

        if (choice !== "Custom")
            calculateTipsBasedOnPercentage(choice)
        else {
            setTipsAmount('')
            setTotalAmount(total)
        }

    }

    const calculateTipsBasedOnPercentage = (percent) => {

        let tips = ((percent / 100) * total)
        setTipsAmount(tips)
        setTotalAmount(total + tips)

    }

    return (
        <>
            <AppBar style={{ position: 'static', backgroundColor: "#003366" }}>
                <Toolbar>
                    <IconButton style={{ marginLeft: -20, color: "white" }} onClick={toggleDrawer} color="default" aria-label="ArrowBackIcon">
                        <ArrowBackIcon />
                    </IconButton>
                    <Typography variant="h6">Payment</Typography>
                </Toolbar>
            </AppBar>

            <SquarePayment subTotal={25} taxes={3.75} tips={tipsAmount} total={totalAmount} />

            <div style={{ marginBottom: 230 }}>
                <Card className={classes.card}>
                    <CardHeader
                        avatar={
                            <AttachMoneyIcon />
                        }
                        title="Tips"
                    />
                    <CardContent>
                        <Grid justify="space-between" container style={styles}>
                            <Grid item>
                                None
                        </Grid>
                            <Grid item>
                                <>
                                    <Checkbox
                                        tabIndex={-1}
                                        disableRipple
                                        checked={tipsAmountChoice === 0}
                                        icon={<RadioButtonUncheckedIcon />}
                                        checkedIcon={<RadioButtonCheckedIcon />}
                                        size={"medium"}
                                        onChange={() => handleTipsChoice(0)}
                                    />
                                </>
                            </Grid>
                        </Grid>
                        <Divider />
                        <Grid justify="space-between" container style={styles}>
                            <Grid item>
                                12%
                        </Grid>
                            <Grid item>
                                <>
                                    <Checkbox
                                        tabIndex={-1}
                                        disableRipple
                                        checked={tipsAmountChoice === 12}
                                        icon={<RadioButtonUncheckedIcon />}
                                        checkedIcon={<RadioButtonCheckedIcon />}
                                        size={"medium"}
                                        onChange={() => handleTipsChoice(12)}
                                    />
                                </>
                            </Grid>
                        </Grid>
                        <Divider />
                        <Grid justify="space-between" container style={styles}>
                            <Grid item>
                                15%
                        </Grid>
                            <Grid item>
                                <>
                                    <Checkbox
                                        tabIndex={-1}
                                        disableRipple
                                        checked={tipsAmountChoice === 15}
                                        icon={<RadioButtonUncheckedIcon />}
                                        checkedIcon={<RadioButtonCheckedIcon />}
                                        size={"medium"}
                                        onChange={() => handleTipsChoice(15)}
                                    />
                                </>
                            </Grid>
                        </Grid>
                        <Divider />
                        <Grid justify="space-between" container style={styles}>
                            <Grid item>
                                18%
                        </Grid>
                            <Grid item>
                                <>
                                    <Checkbox
                                        tabIndex={-1}
                                        disableRipple
                                        checked={tipsAmountChoice === 18}
                                        icon={<RadioButtonUncheckedIcon />}
                                        checkedIcon={<RadioButtonCheckedIcon />}
                                        size={"medium"}
                                        onChange={() => handleTipsChoice(18)}
                                    />
                                </>
                            </Grid>
                        </Grid>
                        <Divider />
                        <Grid justify="space-between" container style={styles}>
                            <Grid item>
                                Custom
                        </Grid>
                            <Grid item>
                                <>
                                    <Checkbox
                                        tabIndex={-1}
                                        disableRipple
                                        checked={tipsAmountChoice === "Custom"}
                                        icon={<RadioButtonUncheckedIcon />}
                                        checkedIcon={<RadioButtonCheckedIcon />}
                                        size={"medium"}
                                        onChange={() => handleTipsChoice("Custom")}
                                    />
                                </>
                            </Grid>
                        </Grid>
                        {tipsAmountChoice === "Custom" &&
                            <FormControl fullWidth>
                                <Input
                                    id="standard-adornment-amount"
                                    placeholder="Enter an amount"
                                    value={tipsAmount}
                                    onChange={event => {
                                        const { value } = event.target
                                        setTipsAmount(value)
                                    }}
                                    startAdornment={<InputAdornment position="start">$</InputAdornment>}
                                />
                            </FormControl>
                        }
                    </CardContent>
                </Card>
            </div>
        </>
    )
}